export const PAGE_OG_TYPE = { article: "article", website: "website" } as const;
